import PageStyle from "@/styles/pages/errors/_index.module.scss";
import Image from 'next/image';

export default function Error429(){
    return (

    <div className={`${PageStyle.NewJob}`}>

    <div className={PageStyle.NewJob__Container}>
      <div className={PageStyle.Error}>
      <Image src='/images/errors/500.png' height={153} width={293} alt=''></Image>

          <h1>429</h1>

          <h3>Too many requests!!</h3>

{/*           <p>Duis a nisl dolor. Integer a gravida ligula. Phasellus finibus risus ac orci venenatis pretium. Duis a imperdiet justo, sagittis volutpat tortor. </p>
 */}      </div>
      </div></div>
    )
}
